import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {Map} from 'immutable';
import localeMap from 'constants/Locales'

class Match extends React.Component {
    static propTypes = {
        match: React.PropTypes.instanceOf(Map).isRequired,
        languageId: React.PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.match !== nextProps.match || this.props.languageId !== nextProps.languageId;
    }

    renderMatchDate(date) {
        const timezone = moment.tz.guess();

        const locale = localeMap[this.props.languageId];
        moment.locale('uz');

        moment.updateLocale('en', {
            calendar : {
                sameDay : '[Today at] HH:mm',
                nextDay : '[Tomorrow at] HH:mm',
                lastWeek : 'D MMMM [at] HH:mm',
                nextWeek : 'D MMMM [at] HH:mm',
                sameElse : 'D MMMM [at] HH:mm'
            }
        });

        moment.updateLocale('ru', {
            calendar : {
                sameDay : '[Сегодня в] HH:mm',
                nextDay : '[Завтра в] HH:mm',
                lastWeek : 'D MMMM [в] HH:mm',
                nextWeek : 'D MMMM [в] HH:mm',
                sameElse : 'D MMMM [в] HH:mm'
            }
        });

        moment.updateLocale('uz', {
            calendar : {
                sameDay : '[Bugun soat] HH:mm',
                nextDay : '[Ertaga soat] HH:mm',
                lastWeek : 'D MMMM [в] HH:mm',
                nextWeek : 'D MMMM [в] HH:mm',
                sameElse : 'D MMMM [в] HH:mm'
            }
        });

        date.locale(locale).tz(timezone);

        return (
            <span className="cell event-date">
                {date.calendar()}
            </span>
        )
    }

    render() {
        const {match} = this.props;

        let matchName = match.get('name');
        const notice = match.get('notice');
        if (notice) {
            matchName = `${matchName} (${notice})`;
        }

        const matchStartTime = match.get('startDate');

        let tv = null;
        const channel = match.get('channel', null);
        if (channel !== null) {
            tv = (
                <span className="tv">
                    <div className="hint hint--broadcast">{channel}</div>
                </span>
            );
        }

        return (
            <div className="event">
                <div className="event-header">
                    <div className="table">
                        <div className="row">
                            <span className="cell main">
                                <span className="event-name">
                                    {matchName}
                                </span>
                                <span className="cell-main tools">
                                    {tv}
                                </span>
                            </span>
                            {this.renderMatchDate(matchStartTime)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    const languageId = state.application.get('languageId');

    return {
        languageId
    };
}

export default connect(select)(Match);



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/components/Match.jsx